export const HIGH_CONFIDENCE_MIN = 0.66;
export const MEDIUM_CONFIDENCE_MIN = 0.33;
export const classifyConfidence = (confidence)=>{
    if (confidence >= HIGH_CONFIDENCE_MIN) return 'high';
    if (confidence >= MEDIUM_CONFIDENCE_MIN) return 'medium';
    return 'low';
};
